module.exports = __webpack_public_path__ + "img/00031.00fe32c7.webp";